import { ThemeTypography } from "@insite/mobius/globals/baseTheme";
import { colorPalette, fontFamily, fontFamilyAlt, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const headingCommon = {
    fontFamily,
    lineHeight: "normal",
    weight: 500,
    color: colorPalette.common.global.secondaryGray,
    mergeCss: true,
};

export const headingCommonAlt = {
    fontFamily: fontFamilyAlt,
    lineHeight: "normal",
    weight: 500,
    color: colorPalette.common.global.secondaryGray,
    mergeCss: true,
};

export const bodyCommon = {
    fontFamily: fontFamilyAlt,
    size: "16px",
    lineHeight: "24px",
    weight: 400,
    color: colorPalette.common.global.secondaryGray,
    mergeCss: true,
};

export const typography: ThemeTypography = {
    h1: {
        ...headingCommon,
        size: "44px",
        lineHeight: "50px",
        css: css`
            margin-bottom: 1rem;
            ${mediaQueriesBP.maxMD} {
                font-size: 28px;
                line-height: 34px;
            }
        `,
    },
    h2: {
        ...headingCommon,
        size: "40px",
        lineHeight: "48px",
        css: css`
            margin-bottom: 1rem;
            ${mediaQueriesBP.maxMD} {
                font-size: 26px;
                line-height: normal;
            }
        `,
    },
    h3: {
        ...headingCommon,
        size: "36px",
        lineHeight: "normal",
        css: css`
            margin-bottom: 1rem;
            ${mediaQueriesBP.maxMD} {
                font-size: 22px;
                line-height: 26px;
            }
        `,
    },
    h4: {
        ...headingCommon,
        size: "24px",
        lineHeight: "normal",
        weight: 400,
        transform: "uppercase",
        css: css`
            margin-bottom: 1rem;
            ${mediaQueriesBP.maxMD} {
                font-size: 21px;
                line-height: 26px;
            }
        `,
    },
    h5: {
        ...headingCommon,
        size: "21px",
        lineHeight: "25px",
        weight: 400,
        transform: "uppercase",
        css: css`
            margin: 0 0 1rem;
            ${mediaQueriesBP.maxMD} {
                font-size: 19px;
                line-height: normal;
            }
        `,
    },
    h6: {
        ...headingCommon,
        size: "16px",
        weight: 700,
        lineHeight: "24px",
        css: css`
            margin: 0 0 1rem;
        `,
    },
    headerPrimary: {
        ...headingCommon,
    },
    headerSecondary: {
        ...headingCommon,
    },
    headerTertiary: {
        ...headingCommon,
    },
    body: {
        ...bodyCommon,
        css: css`
            padding: 0;
        `,
    },
    p: {
        ...bodyCommon,
    },
    legend: {
        ...bodyCommon,
        size: "12px",
        lineHeight: "normal",
        transform: "none",
    },
};
